<template>
  <v-container>
    <h1 class="text-center text-xl font-semibold py-5">Ups... coś poszło nie tak <font-awesome-icon :icon="['far', 'frown']" /></h1>

    <p>Prosimy o ponowne wypełnienie formularza.</p>
    <p>Jeśli błąd się powtórzy prosimy o kontakt.</p>

  </v-container>
</template>

<script>
export default {};
</script>

<style>
</style>